import Container from "modules/Core/sub-modules/ui-kit/components/Container";
import Button from "modules/Core/sub-modules/ui-kit/components/Button";
import styles from "./styles.module.scss";

const TabsHeader = ({ tabs, activeIndex, setActiveIndex }) => (
    <Container flex alignCenter className={styles.tabs}>
        {tabs.map(({ title }, i) => (
            <Button
                key={title ?? i}
                type="button"
                active={activeIndex === i}
                onClick={() => setActiveIndex(i)}
                className={activeIndex === i ? styles.activeTab : styles.tab}
            >
                {title}
            </Button>
        ))}
    </Container>
);

export default TabsHeader;
